import React from 'react';
import {ElementForm, Input} from "../../form-component";
import {ModelManager} from "../../model-manager";
import {HistoryManager} from '../../history-manager';
import {alertActions} from "../../user-manager";
import {connect} from 'react-redux';

class RegisterForm extends ElementForm {
    constructor(props) {
        super(props);

        const user = {
            '@id': '/api/users',
            email: '',
            repeatEmail: '',
            plainPassword: '',
            repeatPassword: '',
            address: '',
            zipcode: '',
            city: '',
            firstname: '',
            lastname: '',
            phone: ''
        };

        const requiredFields = [
            'email',
            'repeatEmail',
            'plainPassword',
            'repeatPassword',
            'firstname',
            'lastname',
        ];

        super(props, user, requiredFields);
    }

    submit(e) {
        e.preventDefault();
        const {dispatch} = this.props;

        let violations = [];

        for (let requiredField of this.state.requiredFields) {
            if (this.state.element[requiredField] === '') {
                violations.push({propertyPath: requiredField, message: 'Cette valeur est obligatoire.'});
            }
        }

        if (this.state.element.email !== this.state.element.repeatEmail) {
            violations.push({propertyPath: 'email', message: 'Les emails ne correspondent pas.'});
        }

        if (this.state.element.plainPassword !== this.state.element.repeatPassword) {
            violations.push({propertyPath: 'plainPassword', message: 'Les mots de passe ne correspondent pas.'});
        }

        if (violations.length === 0) {
            ModelManager.save(this.state.element).then((element) => {
                this.setState({element});
                HistoryManager.getHistory().push('/login');

                dispatch(alertActions.success('Vous êtes inscrit. Vous devez valider votre inscription en cliquant sur le lien reçu par email.'));
            }).catch(error => {
                error.violations ? this.mapErrors(error.violations) : this.cleanErrors();
            });
        } else {
            this.mapErrors(violations);
        }
    }

    render() {
        window.location.hash = '#container';

        return (
            <div className="container register page">
                <div className="title">Créer un compte</div>

                <div id="fields">

                    <form className="ajax-contact-form form-horizontal" noValidate>
                        <h5 className="clear">Mes identifiants</h5>

                        <div className="form-row">
                            <div className="form-group col-md-5">
                                <Input name="email" label="Email" type="email"
                                       value={this.state.element.email}
                                       errors={this.state.errors.email} updateElement={this.updateElement}
                                       required={this.isRequired('email')}/>
                            </div>


                            <div className="form-group col-md-5">
                                <Input name="repeatEmail" label="Confirmez votre email" type="email"
                                       value={this.state.element.repeatEmail}
                                       errors={this.state.errors.repeatEmail} updateElement={this.updateElement}
                                       required={this.isRequired('repeatEmail')}/>
                            </div>
                        </div>

                        <div className="form-row clear">
                            <div className="form-group col-md-5">
                                <Input name="plainPassword" label="Mot de passe" type="password"
                                       value={this.state.element.plainPassword}
                                       errors={this.state.errors.plainPassword} updateElement={this.updateElement}
                                       required={this.isRequired('plainPassword')}/>
                            </div>

                            <div className="form-group col-md-5">
                                <Input name="repeatPassword" label="Confirmez votre mot de passe" type="password"
                                       value={this.state.element.repeatPassword}
                                       errors={this.state.errors.repeatPassword} updateElement={this.updateElement}
                                       required={this.isRequired('repeatPassword')}/>
                            </div>
                        </div>

                        <h5 className="clear">Mes coordonnées</h5>

                        <div className="form-row">
                            <div className="form-group col-md-5">
                                <Input name="lastname" label="Nom" type="text" errors={this.state.errors.lastname}
                                       value={this.state.element.lastname}
                                       updateElement={this.updateElement} required={this.isRequired('lastname')}/>
                            </div>

                            <div className="form-group col-md-5">
                                <Input name="firstname" label="Prénom" type="text"
                                       value={this.state.element.firstname}
                                       errors={this.state.errors.firstname} updateElement={this.updateElement}
                                       required={this.isRequired('firstname')}/>
                            </div>
                        </div>

                        <div className="form-row clear">
                            <div className="form-group col-md-5">
                                <Input name="phone" label="Téléphone" type="text" errors={this.state.errors.phone}
                                       value={this.state.element.phone}
                                       updateElement={this.updateElement} required={this.isRequired('phone')}/>
                            </div>
                        </div>


                        <div className="form-row">
                            <div className="form-group col-md-5">
                                <Input name="address" label="Adresse" type="text" errors={this.state.errors.address}
                                       value={this.state.element.address}
                                       updateElement={this.updateElement} required={this.isRequired('address')}/>
                            </div>

                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-5">
                                <Input name="zipcode" label="Code postal" type="text" errors={this.state.errors.zipcode}
                                       value={this.state.element.zipcode}
                                       updateElement={this.updateElement} required={this.isRequired('zipcode')}/>
                            </div>

                            <div className="form-group col-md-5">
                                <Input name="city" label="Ville" type="text" errors={this.state.errors.city}
                                       value={this.state.element.city}
                                       updateElement={this.updateElement} required={this.isRequired('city')}/>
                            </div>
                        </div>


                        <div className="col-md-12">
                            <button
                                type="submit" className="submit" onClick={this.submit}>Créer un
                                compte
                            </button>
                        </div>
                    </form>

                    <div className="col-md-12">
                        <small className="form-text text-muted">
                            (*) Champs requis.
                        </small>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

const ConnectedRegisterForm = connect(mapStateToProps)(RegisterForm);
export {ConnectedRegisterForm as RegisterForm};